import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = typeof window !== 'undefined' && localStorage.getItem('token');
  
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;